import React from 'react';

import { Mentionable } from '../ui/EditableInput/types';
import { useMentionPlugin } from '../ui/EditableInput/AddMentionButton/useMentionPlugin';
import { useNullableSavedRepliesContext } from './SavedRepliesContext';

export const useSavedReplyMentionPlugin = ({
  enable,
  isUrlInput,
  lastValue,
  isKeyPressing,
  position,
}: {
  enable?: boolean;
  isUrlInput?: boolean;
  isKeyPressing: boolean;
  lastValue?: string | null;
  position?: string;
}) => {
  const savedRepliesContext = useNullableSavedRepliesContext();

  const mentions: Mentionable[] = React.useMemo(() => {
    const savedReplies = savedRepliesContext?.savedReplies ?? [];
    return savedReplies.map((savedReply) => ({
      name: `#${savedReply.shortcut}`,
      value: savedReply.content,
    }));
  }, [savedRepliesContext?.savedReplies]);

  const { mentionSuggestions, mentionSuggestionsOpen, mentionSuggestionsPlugin } = useMentionPlugin(
    {
      isUrlInput,
      lastValue,
      isKeyPressing,
      mentionTrigger: '#',
      mentions: enable ? mentions : undefined,
      position,
    }
  );

  return {
    savedReplySuggestions: mentionSuggestions,
    savedReplySuggestionsOpen: mentionSuggestionsOpen,
    savedReplySuggestionsPlugin: mentionSuggestionsPlugin,
  };
};
